import { List } from 'immutable';
import { fixMediaUrl, parseMetatagTitle } from '../../../../../Shared/api/drupal/drupalApi';
import { node_location_guard, node_location_parser } from '../../../../../Shared/api/drupal/parser';
import { catchError, drupalUrl, get } from '../../../../custom_api/api';
export const getDrupalOvaticLocations = async ()=>{
    const apiResult = await get(`${drupalUrl}/api/rooms`);
    if (apiResult == "loading" || apiResult == "error") return "error";
    const locationDetails = List(apiResult).reduce((acc, node)=>{
        var _n_field_media_field_media_image_image, _n_field_media_field_media_image_image1, _n_field_media_field_media_image_image2, _n_field_media;
        if (!node_location_guard(node)) return acc;
        const n = node_location_parser(node);
        const room = {
            title: parseMetatagTitle(n.metatag) || '',
            description: n.field_short_description || '',
            ovatic_id: Number(n.field_location_id),
            url: n.path || '',
            imageUrl: n.field_media ? fixMediaUrl(((_n_field_media_field_media_image_image = n.field_media.field_media_image.image) === null || _n_field_media_field_media_image_image === void 0 ? void 0 : _n_field_media_field_media_image_image.style_urls["420x320"]) || '') : "",
            imageUrlFallback: n.field_media ? fixMediaUrl(((_n_field_media_field_media_image_image1 = n.field_media.field_media_image.image) === null || _n_field_media_field_media_image_image1 === void 0 ? void 0 : _n_field_media_field_media_image_image1.style_urls["4x3"]) || '') : "",
            imageUrlLarge: n.field_media ? fixMediaUrl(((_n_field_media_field_media_image_image2 = n.field_media.field_media_image.image) === null || _n_field_media_field_media_image_image2 === void 0 ? void 0 : _n_field_media_field_media_image_image2.style_urls["840x640"]) || '') : "",
            image_alt: ((_n_field_media = n.field_media) === null || _n_field_media === void 0 ? void 0 : _n_field_media.field_media_image.alt) || '',
            price: n.field_price === null ? undefined : Number(n.field_price)
        };
        return acc.push(room);
    }, List());
    return locationDetails;
};
export const getOvaticLocations = async ()=>{
    try {
        let res = await fetch(`/api/v1/ovatic/GetAllLocations`);
        let json = await res.json();
        return json["locations"];
    } catch (e) {
        return catchError()(e);
    }
};
export const postProcessDrupalRoom = (room)=>{
    const clean = {
        ...room,
        ovatic_id: Number(room.ovatic_id)
    };
    return clean;
};
